<template>
  <div id="app">
      <div class="tabs is-fullwidth">
        <ul>
          <router-link to="/" tag="li"><a>Új</a></router-link>
          <router-link to="/list" tag="li"><a>Lista</a></router-link>
          <router-link to="/test" tag="li"><a>Teszt</a></router-link>
        </ul>
      </div>
    <router-view></router-view>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js';
import shared_data from '@/shared_data.js'

export default {
  name: 'App',
  data () {
    return {
      shdata: shared_data,
      loggedOn: true
    }
  },
  components: {
//    NewTab, ListTab, TestTab, Login
  },
  methods: {
    logon() {
      this.$data.loggedOn = false
      this.$router.push("/login")
    },
    loggedon() {
      this.$data.loggedOn = true
      this.$router.go(-1)
    }

  },
  mounted () {
    EventBus.$on("NEED_AUTH",this.logon)
    EventBus.$on("AUTH_SUCCESS",this.loggedon)
  }
}
</script>

<style>
</style>
